export default "__VITE_ASSET__D_nY_CCp__"